export default __webpack_public_path__ + "static/media/our-partner-new-5.44de4650.jpg";